import { forwardRef } from 'react';
import { v4 as uuid } from 'uuid';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    const id = uuid();

    return (
        <SvgIcon ref={ref} {...props}>
            <g clipPath={`url(#${id})`}>
                <rect width='24' height='24' fill='#333239' />
                <path
                    d='M6.04999 19.2166V17.1833H4.01666V19.2166H3V14.1333H4.01666V16.1666H6.04999V14.1333H7.06665V19.2166H6.04999ZM9.09998 19.2166V15.15H7.67665V14.1333H11.4383V15.15H10.1166V19.2166H9.09998ZM12.15 19.2166V14.1333H13.1666L14.59 17.59H14.6916L16.2166 14.1333H17.2333V19.2166H16.2166V16.065H16.1149L14.9966 18.6066H14.3866L13.2683 16.065H13.1666V19.2166H12.15ZM21.2999 19.2166H18.2499V14.1333H19.2666V18.2H21.2999V19.2166ZM11.54 7.21999L9.20164 9.55832L11.54 11.8966L10.93 13.1166L7.37165 9.55832L10.93 6L11.54 7.21999ZM12.76 11.8966L15.0983 9.55832L12.76 7.21999L13.37 6L16.9283 9.55832L13.37 13.1166L12.76 11.8966Z'
                    fill='white'
                />
            </g>
            <defs>
                <clipPath id={id}>
                    <rect width='24' height='24' rx='4' fill='white' />
                </clipPath>
            </defs>
        </SvgIcon>
    );
});
